/**
Author - Babajan Patan
Git - https://github.com/babajanpatan
* */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  togglerColorBackground: PropTypes.string.isRequired
};

const Toggler = ({
  checked,
  onChange,
  disabled,
  togglerColorBackground
}) => {
  return (
    <TogglerContainer>
      <Input
        checked={checked}
        disabled={disabled}
        type="checkbox"
        onChange={onChange}
      />
      <Slider
        checked={checked}
        disabled={disabled}
        togglerColorBackground={togglerColorBackground}
      >
        <SliderBefore
          checked={checked}
          disabled={disabled}
        />
      </Slider>
    </TogglerContainer>
  );
};



const TogglerContainer = styled.label`
  font-size: 14px;
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

`;

const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  position: absolute;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.checked
      ? props.togglerColorBackground
        ? `${props.togglerColorBackground}`
        : "#7E53ED"
      : "#F1ECFB"};
  transition: 0.4s;
  border-radius: 30px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)}; // Lo
`;

const SliderBefore = styled.span`
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  border-radius: 20px;
  left: 2px;
  bottom: 2px;
  z-index: 2;
  background-color: ${(props) => (props.checked ? "#F1ECFB" : "#7E53ED")};
  transition: 0.4s;
  transform: ${(props) => (props.checked && !props.disabled ? "translateX(20px)" : "translateX(0)")};

`;


Toggler.propTypes = propTypes;
export default Toggler;
